import * as React from "react";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
  Avatar,
} from "@mui/material";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ dpList }) {
  const navigate = useNavigate();

  function handleBrandNavigation(brandID) {
    navigate(pages.unverifiedPageDetails.route + "?brandID=" + brandID);
  }

  return (
    <TableContainer
      sx={{ maxHeight: "90%", borderRadius: "10px" }}
      component={Paper}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            <StyledTableCell />

            <StyledTableCell>Brand Name</StyledTableCell>
            <StyledTableCell>Connection Url</StyledTableCell>
            {/* <StyledTableCell>Port</StyledTableCell> */}
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {dpList.map((connection) => (
            <StyledTableRow>
              <Fragment>
                <StyledTableCell component="th" scope="row">
                  <Avatar
                    onClick={() =>
                      handleBrandNavigation(
                        connection.connectionDetails.brand_id
                      )
                    }
                    src={connection?.brandDetails?.logo}
                    style={{ height: "60px", width: "60px", cursor: "pointer" }}
                  />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {connection?.brandDetails?.brand_name.replace(/_/g, " ") ||
                    "-"}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {connection?.connectionDetails?.connection_url || "N.A"}
                </StyledTableCell>

                {/* <StyledTableCell component="th" scope="row">
                  {connection?.connectionDetails?.port || "N.A"}
                </StyledTableCell> */}

                <StyledTableCell component="th" scope="row">
                  <StatusChip connection={connection} />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <Tooltip title="View Brand">
                    <Icon
                      onClick={() =>
                        navigate(
                          pages.dpOnBoardingDetails.route +
                            connection.connectionDetails.connection_id +
                            "?brandID=" +
                            connection?.connectionDetails?.brand_id
                        )
                      }
                    >
                      <CgEye style={{ height: "20px", width: "20px" }} />
                    </Icon>
                  </Tooltip>
                </StyledTableCell>
              </Fragment>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function StatusChip({ connection }) {
    let color;
    if (connection?.connectionDetails?.status === "ACTIVE") {
      color = colors.lightGreen;
    }

    if (connection?.connectionDetails?.status === "INACTIVE") {
      color = colors.error;
    }

    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          // top: "9px",
          fontSize: "13px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={connection?.connectionDetails?.status}
      />
    );
  }
}
